import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import * as agent from "../agent";
import Dropzone from "react-dropzone";
import { CLIENT_LOADED } from "../constants/actionTypes";
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import PrintLink from './PrintLink';
import OuterLink from './OuterLink';
import DeleteIcon from '@material-ui/icons/Delete';

class securityCronos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            passportScanFile: null,
            confirmFile: null,
            requestingCronos: false,
            fetchingCronos: false,
            submitRequestDisabled: false,
            submitFetchDisabled: false,
            requestError: false,
            requestErrorMessage: ""
        }
    }
    requestCronos = () => {
        if(window.confirm("Подтвердите запрос платной проверки")) {
            this.setState({ submitRequestDisabled: true, requestingCronos: true });

            const { carId, clientDetails, dispatch } = this.props;
            const { passportScanFile, confirmFile } = this.state;

            agent.Clients.cronosRequest(carId, clientDetails, { passportScanFile, confirmFile })
                .then(client => {
                    dispatch({type: CLIENT_LOADED, payload: client});
                    this.setState({ requestingCronos: false });
                })
                .catch(err => {
                    this.setState({ requestError: true, requestErrorMessage: err.message, requestingCronos: false })
                })
        }

    }
    fetchCronos = () => {

        this.setState({ submitFetchDisabled: true, fetchingCronos: true });
        const { carId, fetchRequestId, dispatch } = this.props;

        agent.Clients.cronosFetch(carId, fetchRequestId)
            .then(client => {
                dispatch({type: CLIENT_LOADED, payload: client});
                this.setState({ fetchingCronos: false });
            })
            .catch(err => {
                this.setState({ fetchError: true, fetchErrorMessage: err.message, fetchingCronos: false })
            })
    }
    render() {

        const { isCronosRequested,
                isCronosFetched,
                cronosReportLink,
                cronosRequestDate,
                cronos = {},
                clientDetails: {
                    lastname,
                    firstname,
                    patronymic,
                    birthDate,
                    passportSerie,
                    passportNumber,
                    address
                } = {} } = this.props;
        const { requestingCronos,
                fetchingCronos,
                submitRequestDisabled,
                submitFetchDisabled,
                requestError,
                requestErrorMessage,
                fetchError,
                fetchErrorMessage,
                passportScanFile,
                confirmFile } = this.state;
        const isEmptyFields = [lastname, firstname, patronymic, birthDate, passportSerie, passportNumber, address].some(f => String(f).length === 0) || !passportScanFile || !confirmFile;
        let passportDropzoneRef;
        let confirmDropzoneRef;
        return (
            <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={16} style={{ marginTop: 20, marginBottom: 20 }}>
                {requestError &&
                    <Grid item>
                        <Typography paragraph>Возникла ошибка при выполнении запроса: {requestErrorMessage}. Устраните ее и повторите попытку</Typography>
                    </Grid>
                }
                {!isCronosRequested && !isCronosFetched &&
                    <React.Fragment>
                        <Grid item>
                            {requestingCronos ?
                                <Typography paragraph >Отправка запроса. Ожидайте...</Typography> :
                                <Typography paragraph >Запрос информации от сервиса promoneyclub по СБ CRONOS не производился. Проверьте и при необходимости данные клиента перед запросом:</Typography>
                            }
                            <Typography paragraph >Фамилия: '{lastname}'</Typography>
                            <Typography paragraph >Имя: '{firstname}'</Typography>
                            <Typography paragraph >Отчество: '{patronymic}'</Typography>
                            <Typography paragraph >Дата рождения: '{birthDate}'</Typography>
                            <Typography paragraph >Серия паспорта: '{passportSerie}'</Typography>
                            <Typography paragraph >Номер паспорта: '{passportNumber}'</Typography>
                            <Typography paragraph >Адрес регистрации: '{address}'</Typography>
                            <PrintLink href={agent.src.printAgreement({lastname, firstname, patronymic, birthDate, passportSerie, passportNumber})}
                                       label="Шаблон согласия на обработку" />
                        </Grid>
                        <Grid item>
                            <Dropzone className="hidden-dropzone"
                                      ref={(node) => { passportDropzoneRef = node; }}
                                      onDrop={files => this.setState({ passportScanFile: files[0] })} />
                                {passportScanFile ?
                                    <Chip icon={ <DeleteIcon />}
                                          onClick={e => {e.preventDefault(); this.setState({passportScanFile: null});}}
                                          label={`Добавлен файл ${passportScanFile.name}`} />
                                    :
                                    <Button size="medium"
                                            color="primary"
                                            onClick={() => { passportDropzoneRef.open() }}
                                            variant="contained" >
                                        Загрузите скан паспорта
                                    </Button>
                                }
                        </Grid>
                        <Grid item>
                            <Dropzone className="hidden-dropzone"
                                      ref={(node) => { confirmDropzoneRef = node; }}
                                      onDrop={files => this.setState({ confirmFile: files[0] })} />
                                {confirmFile ?
                                    <Chip icon={ <DeleteIcon />}
                                          onClick={e => {e.preventDefault(); this.setState({confirmFile: null});}}
                                          label={`Добавлен файл ${confirmFile.name}`} />
                                    :
                                    <Button size="medium"
                                            color="primary"
                                            onClick={() => { confirmDropzoneRef.open() }}
                                            variant="contained" >
                                        Загрузите согласие на обработку
                                    </Button>
                                }
                        </Grid>
                        <Grid item>
                            <Button type="submit"
                                    onClick={this.requestCronos}
                                    disabled={submitRequestDisabled || isEmptyFields}
                                    size="large"
                                    color="primary"
                                    variant="contained"> Запрос информации </Button>
                        </Grid>
                    </React.Fragment>
                }
                {fetchError &&
                    <Grid item>
                        <Typography paragraph>Возникла ошибка при попытке получить результат: {fetchErrorMessage}.</Typography>
                    </Grid>
                }
                {isCronosRequested && !isCronosFetched &&
                    <React.Fragment>
                        {fetchingCronos ?
                            <Grid item>
                                <Typography paragraph>Отправка запроса. Ожидайте...</Typography>
                            </Grid>
                            :
                            <Grid item>
                                <Typography paragraph>Запрос информации был осуществлен {new Date(cronosRequestDate).toLocaleString()}. В соответствии с регламентом сервиса promoneyclub обработка результатов может занимать до 15 минут рабочего времени</Typography>
                            </Grid>
                        }
                        <Grid item>
                            <Button type="submit"
                                    onClick={this.fetchCronos}
                                    disabled={submitFetchDisabled}
                                    size="large"
                                    color="primary"
                                    variant="contained"> Запрос результата </Button>
                        </Grid>
                    </React.Fragment>
                }
                {isCronosRequested && isCronosFetched &&
                    <React.Fragment>
                        <Grid item>
                            <Typography paragraph>Статус запроса: {cronos["STATUS|VALUE"] || "Начальный"}</Typography>
                        </Grid>
                        <Grid item>
                            <OuterLink href={cronosReportLink} label={"Просмотр отчета"}/>
                        </Grid>
                    </React.Fragment>
                }
            </Grid>
        );
    }
};


const SecurityCronos = connect(null, null)(reduxForm({form: "security-cronos"})(securityCronos));

export default SecurityCronos;



// WEBPACK FOOTER //
// ./src/components/SecurityCronos.js